import React, { forwardRef, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import clsx from 'clsx';
import WarningIcon from '@/assets/images/warning.svg';

const useStyles = makeStyles((theme) => ({
  root: {},
  codeInputComponent: {
    display: 'inline-block',
    position: 'relative',
    '& input[type=number]::-webkit-inner-spin-button': {
      appearance: 'none',
    },
    '& input': {
      marginRight: '10px',
      width: '44px',
      height: '42px',
      boxSizing: 'border-box',
      border: 'none',
      borderBottom: '2px solid #D3DAE1',
      fontFamily: 'OpenSans',
      fontSize: theme.typography.$fzH2,
      lineHeight: theme.typography.$lhH2,
      textAlign: 'center',
      paddingBottom: '5px',
      color: theme.typography.$dark100,
      backgroundColor: 'transparent',
      '&:focus': {
        outline: 'none',
        borderBottom: `2px solid ${theme.palette.$uploadBorderHover}`,
        backgroundColor: 'transparent',
      },
    },
    '&.focused': {
      '& input': {
        outline: 'none',
        borderBottom: `2px solid ${theme.palette.$uploadBorderHover}`,
      },
    },
    '&.errored': {
      '& input': {
        outline: 'none',
        borderBottom: `2px solid ${theme.palette.$errorRed} !important`,
      },
    },
    '& input[type="password"]': {
      border: 'none !important',
    },
    '@media (max-width: 767px)': {
      '& input': {
        borderRadius: '0px',
        paddingLeft: '.2em',
        paddingRight: '.2em',
        width: '18px',
      },
    },
    '@media (max-width: 360px)': {
      '& input': {
        width: '12px',
      },
    },
  },
  errorMessage: {
    marginTop: '10px',
    padding: '8px',
    height: theme.palette.$lhH2,
    color: theme.palette.$errorRed,
    fontSize: theme.typography.$fzDes,
    lineHeight: theme.typography.$lhDes,
    '& p': {
      margin: 0,
    },
  },
  iconWarning: {
    verticalAlign: 'middle',
    marginRight: '4px',
  },
  label: {
    fontSize: theme.typography.$fzBody,
    lineHeight: theme.typography.$lhH4,
    color: theme.palette.$lightTextGray,
    marginBottom: '56px',
  },
  text: {
    marginTop: 0,
    marginBottom: '24px',
    fontSize: theme.typography.$fzH5,
    lineHeight: theme.typography.$lhH5,
    color: theme.palette.$lightTextGray,
  },
  errorInput: {
    display: 'block',
  },
}));

const CodeInputCustom = forwardRef((props, ref) => {
  const {
    label,
    title,
    className,
    setValue,
    code,
    passwordArr,
    errored,
    errorMessage,
    focused,
    codeFocus,
    clickOutside,
  } = props;
  const classes = useStyles();
  const codeContainerRef = useRef(null);
  const handleClickOutside = (event) => {
    const domNode = codeContainerRef.current;
    if (domNode && !domNode.contains(event.target)) {
      clickOutside();
    }
  };
  const handleChange = (event, index) => {
    const { value: inputValue } = event.target;
    if (/^\d*$/.test(inputValue)) {
      if (inputValue.length > 1) {
        const firstChar = inputValue.charAt(0);
        setValue(firstChar, index);
      } else {
        setValue(inputValue, index);// 更新输入框的值
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.keyCode === 8) {
      setValue('', index);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
  }, []);
  return (
    <div className={clsx(className)}>
      <FormLabel className={classes.label} component="legend">
        {label}
      </FormLabel>
      {title && <p className={classes.text}>{title}</p>}
      <div className={clsx(classes.codeInputComponent, errored ? 'errored' : '', focused ? 'focused' : '')} ref={codeContainerRef}>
        {
          code?.map((item, index) => (
            <input
              onChange={(event) => handleChange(event, index)}
              type={passwordArr[index] ? 'password' : 'text'}
              value={item}
              onFocus={() => codeFocus()}
              ref={ref[index]}
              maxLength="1"
              onKeyDown={(event) => handleKeyDown(event, index)}
              key={index}
            />
          ))
        }
      </div>
      {errored && (
        <div className={classes.errorMessage}>
          <img src={WarningIcon} className={classes.iconWarning} alt="#" />
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
});

{
  /* <CodeInputCustom label="CDP Securities Account number" placeholder={'To find out your number, you may call CDP at +65 6535 7511'} getValue={(e) => console.log(e,"eee")}></CodeInputCustom> */
}
CodeInputCustom.defaultProps = {
  label: '',
  title: 'Enter the OTP to proceed',
  className: '',
  passwordArr: [],
  code: [],
  setValue: _ => _,
  errored: false,
  errorMessage: '',
  focused: false,
  codeFocus: _ => _,
  clickOutside: _ => _,
};

CodeInputCustom.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  passwordArr: PropTypes.array,
  code: PropTypes.array,
  setValue: PropTypes.func,
  errored: PropTypes.bool,
  errorMessage: PropTypes.string,
  focused: PropTypes.bool,
  codeFocus: PropTypes.func,
  clickOutside: PropTypes.func,
};

export default CodeInputCustom;
